import 'react-multi-carousel/lib/styles.css'

import { Trans } from '@lingui/macro'
import { ButtonPrimary } from 'components/Button'
import { DarkCard } from 'components/Card'
import { AutoColumn, ColumnCenter } from 'components/Column'
import { RowBetween, RowCenter } from 'components/Row'
import React, { useState } from 'react'
import { AlertTriangle } from 'react-feather'
import Carousel from 'react-multi-carousel'
import NumberFormat from 'react-number-format'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { tokenToDecimals } from 'utils/tokens'
import { isMobile } from 'utils/userAgent'

import { SportBetModal } from './BetModal'

/* import { SportBetModal } from './BetModal' */

const Container = styled.div`
  width: 100%;
`

const Message = styled.div`
  width: 40%;
  display: flex;
  justify-content: center;
  align-items: center;
  border 1px solid #FF8F00;
  border-radius: 16px;
  margin: auto;
  margin-top: 1rem;
  padding: 8px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
  `};
`

interface ISportProvider {
  id: string
  leagueName: string
  league: string
  sportType: string
}

interface IAcornSportBets {
  player: string
}

interface IAcornSportEvents {
  id: string
  gameIndex: string
  homeTeam: string
  homeScore?: number
  awayTeam: string
  awayScore?: number
  statusId?: number
  startTime: string
  volumen?: string
  volumenHome: string
  volumenAway: string
  volumenDraw: string
  provider: ISportProvider
  bets?: IAcornSportBets[]
}

interface TopMatchesProps {
  topBets: IAcornSportEvents[]
}

function TopMatches({ topBets }: TopMatchesProps) {
  const [isDark] = useDarkModeManager()
  const [betModalIsOpen, setBetModalIsOpen] = useState(false)
  const [scheduleItem, setScheduleItem] = useState<IAcornSportEvents | undefined>()
  const [betPosition, setBetPosition] = useState<number>(0)

  const openModalBet = (item: IAcornSportEvents, position: number) => {
    setBetPosition(position)
    setScheduleItem(item)
    setBetModalIsOpen(true)
  }

  const closeBetModal = () => {
    setBetModalIsOpen(false)
  }

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }

  const calculateRatio = (volumen: string, base: string) => {
    const currentRatio = tokenToDecimals(volumen || '0', 18) / tokenToDecimals(base || '0', 18)
    if (currentRatio === Infinity) {
      return 0
    }
    return currentRatio || 0
  }

  return (
    <Container>
      {topBets && topBets.length > 0 ? (
        <Carousel
          responsive={responsive}
          infinite
          arrows={false}
          autoPlay
          swipeable
          autoPlaySpeed={5000}
          customTransition="transform 10000ms linear"
        >
          {topBets.map((item: IAcornSportEvents, index) => (
            <DarkCard key={index} isDark={isDark} width={isMobile ? '99%' : '95%'} minHeight="260px">
              <AutoColumn>
                <RowCenter minHeight="25px">
                  <img
                    width="64px"
                    src={
                      isDark
                        ? `${process.env.PUBLIC_URL}/images/sports/leagues/${item?.provider.sportType}_White.png`
                        : `${process.env.PUBLIC_URL}/images/sports/leagues/${item?.provider.sportType}.png`
                    }
                    alt=""
                  />
                </RowCenter>
                <RowBetween minHeight="130px" mt="1rem">
                  <ColumnCenter>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/sports/tshirts/${item.provider.sportType}/${item.homeTeam}_Home.svg`}
                      alt="home"
                      width="64px"
                    />
                    <ThemedText.SubHeader textAlign="center">{item.homeTeam}</ThemedText.SubHeader>
                  </ColumnCenter>
                  <ColumnCenter>
                    <ThemedText.MediumHeader textAlign="center">VS</ThemedText.MediumHeader>
                    <ThemedText.Italic textAlign="center">
                      {new Date(Number(item.startTime) * 1000).toLocaleDateString()}
                    </ThemedText.Italic>
                    <ThemedText.Italic textAlign="center">
                      {new Date(Number(item.startTime) * 1000).toLocaleTimeString()}
                    </ThemedText.Italic>
                  </ColumnCenter>
                  <ColumnCenter>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/sports/tshirts/${item.provider.sportType}/${item.awayTeam}_Away.svg`}
                      alt="away"
                      width="64px"
                    />
                    <ThemedText.SubHeader textAlign="center">{item.awayTeam}</ThemedText.SubHeader>
                  </ColumnCenter>
                </RowBetween>
                <RowBetween minHeight="10px" mt="1rem">
                  <ButtonPrimary
                    width="30%"
                    size="10px"
                    disabled={Number(item.startTime) <= Math.floor(Date.now() / 1000)}
                    onClick={() => openModalBet(item, 0)}
                  >
                    <NumberFormat
                      value={calculateRatio(item.volumen || '0', item.volumenHome || '0')}
                      suffix="x"
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                    />
                  </ButtonPrimary>
                  <ButtonPrimary
                    width="30%"
                    size="10px"
                    disabled={Number(item.startTime) <= Math.floor(Date.now() / 1000)}
                    onClick={() => openModalBet(item, 0)}
                  >
                    <NumberFormat
                      value={calculateRatio(item.volumen || '0', item.volumenDraw || '0')}
                      suffix="x"
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                    />
                  </ButtonPrimary>
                  <ButtonPrimary
                    width="30%"
                    size="10px"
                    disabled={Number(item.startTime) <= Math.floor(Date.now() / 1000)}
                    onClick={() => openModalBet(item, 0)}
                  >
                    <NumberFormat
                      value={calculateRatio(item.volumen || '0', item.volumenAway || '0')}
                      suffix="x"
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                    />
                  </ButtonPrimary>
                </RowBetween>
              </AutoColumn>
            </DarkCard>
          ))}
        </Carousel>
      ) : (
        <Message>
          <AlertTriangle size={16} color="#FF8F00" />
          <ThemedText.SubHeader ml="4px" color="#FF8F00">
            <Trans>There are no top matches to bet on</Trans>
          </ThemedText.SubHeader>
        </Message>
      )}
      <SportBetModal
        isOpen={betModalIsOpen}
        titleEvent={scheduleItem?.provider.sportType || ''}
        dateEvent={scheduleItem?.startTime || ''}
        homeTeam={scheduleItem?.homeTeam || ''}
        awayTeam={scheduleItem?.awayTeam || ''}
        onDismiss={closeBetModal}
        itemEvent={scheduleItem}
        onTeamSelect={betPosition}
      />
    </Container>
  )
}

export default TopMatches
